import { useBreakPoints } from 'core';
import { Avatar, Group, Stack, Text } from 'ui';

const WaysToParticipate = () => {
  const { isSmallScreen } = useBreakPoints();
  return (
    <Stack gap={'lg'}>
      <Text fw={600} fz={isSmallScreen ? 18 : 24}>
        Ways to participate
      </Text>

      <Group wrap="nowrap" align="flex-start">
        <Avatar bg="cobalt" color="white" radius="xl" size="sm">
          1
        </Avatar>
        <Stack gap={4}>
          <Text fw={500} fz={14} c="gray.8">
            Donate to 1 or more causes
          </Text>
          <Text fw={400} fz={10} c={'gray.6'}>
            Every donation you make to a cause, Givebacks will donate $5 on your behalf for kids in
            foster care.
          </Text>
        </Stack>
      </Group>

      <Group wrap="nowrap" align="flex-start">
        <Avatar bg="cobalt" color="white" radius="xl" size="sm">
          2
        </Avatar>
        <Stack gap={4}>
          <Text fw={500} fz={14} c="gray.8">
            Enable the iPhone browser extension
          </Text>
          <Text fw={400} fz={10} c={'gray.6'}>
            Once you get the extension, Givebacks will donate $5 on your behalf for kids in foster
            care.
          </Text>
        </Stack>
      </Group>

      <Group wrap="nowrap" align="flex-start">
        <Avatar bg="cobalt" color="white" radius="xl" size="sm">
          3
        </Avatar>
        <Stack gap={4}>
          <Text fw={500} fz={14} c="gray.8">
            Enable the desktop browser extension
          </Text>
          <Text fw={400} fz={10} c={'gray.6'}>
            Once you get the extension, Givebacks will donate $5 on your behalf for kids in foster
            care.
          </Text>
        </Stack>
      </Group>
    </Stack>
  );
};
export { WaysToParticipate };
